module.exports = __webpack_public_path__ + "res/img/wechat_mask_ios.74e1c020.jpg";